// extracted by mini-css-extract-plugin
module.exports = {"container-cotizaciones":"styles_container-cotizaciones__ZanSJ"};